export default "__VITE_ASSET__BNcuFqOk__"